export default __webpack_public_path__ + "static/media/img_16.a3c189c3.JPG";